import { BigNumber as BigNumber$1, utils, Contract, ethers } from 'ethers';
import { Logger } from 'ethers/lib/utils';
import { Signer } from '@ethersproject/abstract-signer';
import BigNumber from 'bignumber.js';
import AuErc20ABI from '@aurigami/contracts/artifacts/contracts/AuErc20.sol/AuErc20.json';
import AuETHABI from '@aurigami/contracts/artifacts/contracts/AuETH.sol/AuETH.json';
import ComptrollerABI from '@aurigami/contracts/artifacts/contracts/Comptroller.sol/Comptroller.json';
import AuriLensABI from '@aurigami/contracts/artifacts/contracts/AuriLens.sol/AuriLens.json';
import EthRepayHelperABI from '@aurigami/contracts/artifacts/contracts/EthRepayHelper.sol/EthRepayHelper.json';
import axios from 'axios';
import TokenLockABI from '@aurigami/contracts/artifacts/contracts/TokenLock.sol/TokenLock.json';
import AuriFairLaunchABI from '@aurigami/contracts/artifacts/contracts/AuriFairLaunch.sol/AuriFairLaunch.json';
import FaucetABI from '@aurigami/contracts/artifacts/contracts/mock/Faucet.sol/Faucet.json';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

var BlockchainEntityRead = function BlockchainEntityRead(networkConnection) {
  this._networkConnection = networkConnection;
};
var BlockchainEntityReadWrite = /*#__PURE__*/function (_BlockchainEntityRead) {
  _inheritsLoose(BlockchainEntityReadWrite, _BlockchainEntityRead);

  function BlockchainEntityReadWrite(networkConnection) {
    if (!(networkConnection.signer instanceof Signer)) {
      throw Error("Signer is not provided when constructing BlockchainEntityReadWrite");
    }

    return _BlockchainEntityRead.call(this, networkConnection) || this;
  }

  return BlockchainEntityReadWrite;
}(BlockchainEntityRead);
var BlockchainEntity = /*#__PURE__*/function () {
  function BlockchainEntity() {}

  var _proto = BlockchainEntity.prototype;

  _proto.read = function read(networkConnection) {
    return new BlockchainEntityRead(networkConnection);
  };

  _proto.readWrite = function readWrite(networkConnection) {
    return new BlockchainEntityReadWrite(networkConnection);
  };

  return BlockchainEntity;
}();

var ComptrollerRewardType;

(function (ComptrollerRewardType) {
  ComptrollerRewardType[ComptrollerRewardType["PLY"] = 0] = "PLY";
  ComptrollerRewardType[ComptrollerRewardType["AURORA"] = 1] = "AURORA";
})(ComptrollerRewardType || (ComptrollerRewardType = {}));
var MarketAction;

(function (MarketAction) {
  MarketAction[MarketAction["Deposit"] = 0] = "Deposit";
  MarketAction[MarketAction["Borrow"] = 1] = "Borrow";
  MarketAction[MarketAction["Withdraw"] = 2] = "Withdraw";
  MarketAction[MarketAction["Repay"] = 3] = "Repay";
  MarketAction[MarketAction["EnableCollateral"] = 4] = "EnableCollateral";
  MarketAction[MarketAction["DisableCollateral"] = 5] = "DisableCollateral";
})(MarketAction || (MarketAction = {}));

var dummyAddress = "0xDEADbeEfEEeEEEeEEEeEEeeeeeEeEEeeeeEEEEeE";
var ETHAddress = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";
var AURORA_CHAINID = 1313161554;
var DECIMAL_PRECISION = 10;
var networkAddresses = {
  auTokens: [{
    name: "auUSDC",
    address: /*#__PURE__*/'0x7A9984522bC81B348d66379ed36Be5BD6147820E'.toLowerCase(),
    underlying: /*#__PURE__*/'0xe1Db3E2f129539b2399d8Cd9e808305c85f0c82f'.toLowerCase()
  }, {
    name: "auETH",
    address: /*#__PURE__*/'0x0e2E6069231928429F36dCA288466bC738e602b3'.toLowerCase(),
    underlying: /*#__PURE__*/ETHAddress.toLowerCase()
  }, {
    name: "auWBTC",
    address: /*#__PURE__*/'0x981bD5832EAB9C8F607940E0e9faCBf8C09ee20a'.toLowerCase(),
    underlying: /*#__PURE__*/'0xA69506eAbdC11BBdAf2259882A02a91B66E6d7E1'.toLowerCase()
  }, {
    name: "auUSDT",
    address: /*#__PURE__*/'0xDACC02a4Ff16Ea3c1515AdbfdCeb7B1F448B79c8'.toLowerCase(),
    underlying: /*#__PURE__*/'0x4459ED2dEFFe0569AE748aD5D7cFEFDeeF667E87'.toLowerCase()
  }, {
    name: "auDAI",
    address: /*#__PURE__*/'0xC337343d1ac9F77B1305261CCD17e3799F088D4B'.toLowerCase(),
    underlying: /*#__PURE__*/'0x1c9998C7768517b83136d3b237a31bc69eDc9028'.toLowerCase()
  }, {
    name: "auPLY",
    address: /*#__PURE__*/'0x5e063B255e2437D75180117905499139a93f16E6'.toLowerCase(),
    underlying: /*#__PURE__*/'0x3cD388c98FE71fE1a37272279F4b50bF27037E23'.toLowerCase()
  }, {
    name: "auWNEAR",
    address: /*#__PURE__*/'0x910fb0AE51761ccCDBbD9ced613e6A4dc571594a'.toLowerCase(),
    underlying: /*#__PURE__*/'0x01B2EDff9b095DC270beca46E2eFB41a3ecEE169'.toLowerCase()
  }],
  misc: {
    COMPTROLLER: /*#__PURE__*/"0x79e62AAfc1675c9F737Ec4Bb949115bfC8D2E2E6".toLowerCase(),
    oracle: /*#__PURE__*/"0xAc99efFDF7a8934e35Ad13880D25127c548A7e6d".toLowerCase(),
    AURIFAIRLAUNCH: /*#__PURE__*/"0xD204fD43bFe4aAEB9aB993c116c1dECdDF1b9F1A".toLowerCase(),
    AURILENS: /*#__PURE__*/'0x0Aa7Ce0f5D6259412602A230C3Ed83eDc857bDa1'.toLowerCase(),
    TOKENLOCK: /*#__PURE__*/'0x1b5c4c6A77f784104662B293a0166B27aF71d2c0'.toLowerCase(),
    FAUCET: /*#__PURE__*/"0xe8b53eE0443620fB8DcEaEB6DE98ED117971c329".toLowerCase(),
    ETHREPAYHELPER: /*#__PURE__*/"0x0b28E2F1767623f2D5Cd59165e79f83E3D63b71F".toLowerCase()
  },
  tokens: {
    AURORA: /*#__PURE__*/dummyAddress.toLowerCase(),
    PLY: /*#__PURE__*/"0x3cD388c98FE71fE1a37272279F4b50bF27037E23".toLowerCase(),
    AURPLY: /*#__PURE__*/dummyAddress.toLowerCase()
  }
};
var BORROW_LIMIT_BUFFER = /*#__PURE__*/new BigNumber(0.95);
var REWARDCLAIMSTART = 1640995200;
var ONE_DAY = 86400;
var ONE_YEAR = ONE_DAY * 365;
var AurPlyPid = 0;
var INF = /*#__PURE__*/BigNumber$1.from(2).pow(256).sub(1);

var decimalRecords = {
  '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee': 18,
  '0xdacc02a4ff16ea3c1515adbfdceb7b1f448b79c8': 8,
  '0x01b2edff9b095dc270beca46e2efb41a3ecee169': 24,
  '0x4459ed2deffe0569ae748ad5d7cfefdeef667e87': 6,
  '0x3cd388c98fe71fe1a37272279f4b50bf27037e23': 18,
  '0x1c9998c7768517b83136d3b237a31bc69edc9028': 18,
  '0x7a9984522bc81b348d66379ed36be5bd6147820e': 8,
  '0x0e2e6069231928429f36dca288466bc738e602b3': 8,
  '0x981bd5832eab9c8f607940e0e9facbf8c09ee20a': 8,
  '0xa69506eabdc11bbdaf2259882a02a91b66e6d7e1': 8,
  '0x910fb0ae51761cccdbbd9ced613e6a4dc571594a': 8,
  '0xe1db3e2f129539b2399d8cd9e808305c85f0c82f': 6,
  '0x5e063b255e2437d75180117905499139a93f16e6': 8,
  '0xc337343d1ac9f77b1305261ccd17e3799f088d4b': 8
};

function formatObject(object) {
  return JSON.stringify(object, null, '  ');
}
function decimalFactor(decimal) {
  return BigNumber$1.from(10).pow(decimal).toString();
}
var isSameAddress = function isSameAddress(address1, address2) {
  return address1.toLowerCase() == address2.toLowerCase();
};
var getCurrentTimestamp = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(provider) {
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", Math.trunc(Date.now() / 1000));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getCurrentTimestamp(_x) {
    return _ref.apply(this, arguments);
  };
}();
function validateAndParseAddress(address) {
  try {
    return utils.getAddress(address);
  } catch (error) {
    throw new Error("Invalid address: " + address);
  }
}
function getDecimal(address) {
  return decimalRecords[address.toLowerCase()];
}
function calcLMRewardApr(rewardsValue, totalStakeValue, frequencyPerYear) {
  if (totalStakeValue.lte(0)) {
    return new BigNumber('999999999');
  }

  return rewardsValue.multipliedBy(frequencyPerYear).dividedBy(totalStakeValue);
}

var Token = function Token(address, decimals) {
  this.address = address.toLowerCase();
  this.decimals = decimals;
};
var PLYToken = /*#__PURE__*/new Token(networkAddresses.tokens.PLY, /*#__PURE__*/getDecimal(networkAddresses.tokens.PLY));
var AURPLYToken = /*#__PURE__*/new Token(networkAddresses.tokens.AURPLY, /*#__PURE__*/getDecimal(networkAddresses.tokens.AURPLY));

var TokenAmount = /*#__PURE__*/function () {
  function TokenAmount(token, amount, isRaw) {
    if (isRaw === void 0) {
      isRaw = true;
    }

    if (isRaw) {
      this.rawAmnt = amount;
    } else {
      this.rawAmnt = new BigNumber(amount).times(decimalFactor(token.decimals)).toFixed(0);
    }

    this.token = token;
  }

  var _proto = TokenAmount.prototype;

  _proto.formattedAmount = function formattedAmount() {
    return new BigNumber(this.rawAmnt).div(decimalFactor(this.token.decimals)).toString();
  };

  _proto.rawAmount = function rawAmount() {
    return this.rawAmnt;
  };

  return TokenAmount;
}();

var abi = [
	{
		inputs: [
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "feed",
				type: "address"
			},
			{
				indexed: false,
				internalType: "string",
				name: "symbol",
				type: "string"
			}
		],
		name: "FeedSet",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "oldAdmin",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "newAdmin",
				type: "address"
			}
		],
		name: "NewAdmin",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "asset",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "previousPriceMantissa",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "requestedPriceMantissa",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "newPriceMantissa",
				type: "uint256"
			}
		],
		name: "PricePosted",
		type: "event"
	},
	{
		constant: true,
		inputs: [
		],
		name: "admin",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				internalType: "address",
				name: "asset",
				type: "address"
			}
		],
		name: "assetPrices",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				internalType: "string",
				name: "symbol",
				type: "string"
			}
		],
		name: "getFeed",
		outputs: [
			{
				internalType: "contract AggregatorV2V3Interface",
				name: "",
				type: "address"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				internalType: "contract QiToken",
				name: "qiToken",
				type: "address"
			}
		],
		name: "getUnderlyingPrice",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "isPriceOracle",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				internalType: "address",
				name: "newAdmin",
				type: "address"
			}
		],
		name: "setAdmin",
		outputs: [
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				internalType: "address",
				name: "asset",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "price",
				type: "uint256"
			}
		],
		name: "setDirectPrice",
		outputs: [
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				internalType: "string",
				name: "symbol",
				type: "string"
			},
			{
				internalType: "address",
				name: "feed",
				type: "address"
			}
		],
		name: "setFeed",
		outputs: [
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				internalType: "contract QiToken",
				name: "qiToken",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "underlyingPriceMantissa",
				type: "uint256"
			}
		],
		name: "setUnderlyingPrice",
		outputs: [
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	}
];
var OracleABI = {
	abi: abi
};

var _format = "hh-sol-artifact-1";
var contractName = "IUniswapV2Pair";
var sourceName = "contracts/interfaces/IUniswapV2Pair.sol";
var abi$1 = [
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			}
		],
		name: "Burn",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			}
		],
		name: "Mint",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount0In",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount1In",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount0Out",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount1Out",
				type: "uint256"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			}
		],
		name: "Swap",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint112",
				name: "reserve0",
				type: "uint112"
			},
			{
				indexed: false,
				internalType: "uint112",
				name: "reserve1",
				type: "uint112"
			}
		],
		name: "Sync",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	},
	{
		inputs: [
		],
		name: "DOMAIN_SEPARATOR",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "MINIMUM_LIQUIDITY",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
		],
		name: "PERMIT_TYPEHASH",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			}
		],
		name: "burn",
		outputs: [
			{
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				internalType: "uint8",
				name: "",
				type: "uint8"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
		],
		name: "factory",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getReserves",
		outputs: [
			{
				internalType: "uint112",
				name: "reserve0",
				type: "uint112"
			},
			{
				internalType: "uint112",
				name: "reserve1",
				type: "uint112"
			},
			{
				internalType: "uint32",
				name: "blockTimestampLast",
				type: "uint32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "initialize",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "kLast",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			}
		],
		name: "mint",
		outputs: [
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "name",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			}
		],
		name: "nonces",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "permit",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "price0CumulativeLast",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "price1CumulativeLast",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			}
		],
		name: "skim",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amount0Out",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amount1Out",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "swap",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
		],
		name: "sync",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "token0",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "token1",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];
var bytecode = "0x";
var deployedBytecode = "0x";
var linkReferences = {
};
var deployedLinkReferences = {
};
var IUniswapV2PairABI = {
	_format: _format,
	contractName: contractName,
	sourceName: sourceName,
	abi: abi$1,
	bytecode: bytecode,
	deployedBytecode: deployedBytecode,
	linkReferences: linkReferences,
	deployedLinkReferences: deployedLinkReferences
};

function fetchPriceFromCoingeckoAPI(_x) {
  return _fetchPriceFromCoingeckoAPI.apply(this, arguments);
}

function _fetchPriceFromCoingeckoAPI() {
  _fetchPriceFromCoingeckoAPI = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(id) {
    var price;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios.get("https://api.coingecko.com/api/v3/simple/price?ids=" + id + "&vs_currencies=usd").then(function (res) {
              return res.data;
            });

          case 2:
            price = _context.sent;
            return _context.abrupt("return", new BigNumber(price[id].usd));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchPriceFromCoingeckoAPI.apply(this, arguments);
}

function fetchPriceFromCoingecko(_x2) {
  return _fetchPriceFromCoingecko.apply(this, arguments);
}

function _fetchPriceFromCoingecko() {
  _fetchPriceFromCoingecko = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(address) {
    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!isSameAddress(address, networkAddresses.tokens.AURORA)) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", fetchPriceFromCoingeckoAPI('aurora-near'));

          case 4:
            throw Error("Unknown token " + address + " in fetchPriceFromCoingecko");

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchPriceFromCoingecko.apply(this, arguments);
}

function fetchLPPositions(_x3, _x4) {
  return _fetchLPPositions.apply(this, arguments);
}

function _fetchLPPositions() {
  _fetchLPPositions = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3(LPAddress, provider) {
    var promises, LPContract, values;
    return runtime_1.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            promises = [];
            LPContract = new Contract(LPAddress, IUniswapV2PairABI.abi, provider);
            promises.push(LPContract.token0());
            promises.push(LPContract.toekn1());
            promises.push(LPContract.getReserves());
            promises.push(LPContract.totalSupply());
            _context3.next = 8;
            return Promise.all(promises);

          case 8:
            values = _context3.sent;
            return _context3.abrupt("return", {
              token0: values[0],
              token1: values[1],
              reserve0: values[2].reserve0,
              reserve1: values[2].reserve1,
              totalSupply: values[3]
            });

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchLPPositions.apply(this, arguments);
}

function fetchLPPrice(_x5, _x6) {
  return _fetchLPPrice.apply(this, arguments);
}

function _fetchLPPrice() {
  _fetchLPPrice = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee4(address, provider) {
    var LPInfo, token0Price, reserveUSD, token1Price, _reserveUSD;

    return runtime_1.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return fetchLPPositions(address, provider);

          case 2:
            LPInfo = _context4.sent;
            _context4.prev = 3;
            _context4.next = 6;
            return fetchPrice(LPInfo.token0, provider);

          case 6:
            token0Price = _context4.sent;
            reserveUSD = token0Price.multipliedBy(LPInfo.reserve0.toString()).multipliedBy(2);
            return _context4.abrupt("return", reserveUSD.multipliedBy(decimalFactor(18)).dividedBy(new BigNumber(LPInfo.totalSupply.toString())));

          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4["catch"](3);
            _context4.prev = 13;
            _context4.next = 16;
            return fetchPrice(LPInfo.token1, provider);

          case 16:
            token1Price = _context4.sent;
            _reserveUSD = token1Price.multipliedBy(LPInfo.reserve1.toString()).multipliedBy(2);
            return _context4.abrupt("return", _reserveUSD.multipliedBy(decimalFactor(18)).dividedBy(new BigNumber(LPInfo.totalSupply.toString())));

          case 21:
            _context4.prev = 21;
            _context4.t1 = _context4["catch"](13);
            throw Error("Unable to fetch price for both tokens of LP " + address);

          case 24:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[3, 11], [13, 21]]);
  }));
  return _fetchLPPrice.apply(this, arguments);
}

function processPriceFromOracle(rawPrice, underlyingDecimal) {
  return new BigNumber(rawPrice.toString()).div(decimalFactor(36 - underlyingDecimal));
}

function fetchPriceFromOracle(_x7, _x8, _x9) {
  return _fetchPriceFromOracle.apply(this, arguments);
}

function _fetchPriceFromOracle() {
  _fetchPriceFromOracle = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee5(auTokenAddress, underlyingDecimal, provider) {
    var oracleContract, rawPrice;
    return runtime_1.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            oracleContract = new Contract(networkAddresses.misc.oracle, OracleABI.abi, provider);
            _context5.next = 3;
            return oracleContract.getUnderlyingPrice(auTokenAddress);

          case 3:
            rawPrice = _context5.sent;
            return _context5.abrupt("return", processPriceFromOracle(rawPrice, underlyingDecimal));

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _fetchPriceFromOracle.apply(this, arguments);
}

function fetchUnderlyingTokensPrices(_x10) {
  return _fetchUnderlyingTokensPrices.apply(this, arguments);
}

function _fetchUnderlyingTokensPrices() {
  _fetchUnderlyingTokensPrices = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee6(provider) {
    var auriLens, auTokenAddresses, underlyingDecimals, rawPrices;
    return runtime_1.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            auriLens = new Contract(networkAddresses.misc.AURILENS, AuriLensABI.abi, provider);
            auTokenAddresses = networkAddresses.auTokens.map(function (auToken) {
              return auToken.address;
            });
            underlyingDecimals = networkAddresses.auTokens.map(function (auToken) {
              return getDecimal(auToken.underlying);
            });
            _context6.next = 5;
            return auriLens.auTokenUnderlyingPriceAll(auTokenAddresses);

          case 5:
            rawPrices = _context6.sent;
            return _context6.abrupt("return", rawPrices.map(function (res, ind) {
              return {
                auToken: res.auToken,
                underlyingPrice: processPriceFromOracle(res.underlyingPrice, underlyingDecimals[ind])
              };
            }));

          case 7:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _fetchUnderlyingTokensPrices.apply(this, arguments);
}

function fetchPrice(_x11, _x12) {
  return _fetchPrice.apply(this, arguments);
}

function _fetchPrice() {
  _fetchPrice = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee7(address, provider) {
    var matchingAuToken;
    return runtime_1.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (!( isSameAddress(address, networkAddresses.tokens.PLY))) {
              _context7.next = 2;
              break;
            }

            return _context7.abrupt("return", new BigNumber(0));

          case 2:
            matchingAuToken = networkAddresses.auTokens.find(function (auToken) {
              return isSameAddress(auToken.underlying, address);
            });

            if (!(matchingAuToken !== undefined)) {
              _context7.next = 7;
              break;
            }

            return _context7.abrupt("return", fetchPriceFromOracle(matchingAuToken.address, getDecimal(address), provider));

          case 7:
            if (!isSameAddress(address, networkAddresses.tokens.AUPLYLP)) {
              _context7.next = 11;
              break;
            }

            return _context7.abrupt("return", fetchLPPrice(address, provider));

          case 11:
            return _context7.abrupt("return", fetchPriceFromCoingecko(address));

          case 12:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _fetchPrice.apply(this, arguments);
}

function fetchValuation(_x13, _x14) {
  return _fetchValuation.apply(this, arguments);
}

function _fetchValuation() {
  _fetchValuation = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee8(tokenAmount, provider) {
    var price;
    return runtime_1.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return fetchPrice(tokenAmount.token.address, provider);

          case 2:
            price = _context8.sent;
            return _context8.abrupt("return", calcValuation(tokenAmount, price));

          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _fetchValuation.apply(this, arguments);
}

function calcValuation(tokenAmount, price) {
  return new BigNumber(tokenAmount.formattedAmount()).multipliedBy(price);
}

var MoneyMarketRead = /*#__PURE__*/function (_BlockchainEntityRead) {
  _inheritsLoose(MoneyMarketRead, _BlockchainEntityRead);

  function MoneyMarketRead(networkConnection, auToken, underlyingAsset) {
    var _this;

    _this = _BlockchainEntityRead.call(this, networkConnection) || this;

    if (isSameAddress(underlyingAsset, ETHAddress)) {
      _this.auToken = new Contract(auToken, AuETHABI.abi, networkConnection.provider);
    } else {
      _this.auToken = new Contract(auToken, AuErc20ABI.abi, networkConnection.provider);
    }

    _this.underlying = new Token(underlyingAsset, getDecimal(underlyingAsset));
    _this._comptroller = new Contract(networkAddresses.misc.COMPTROLLER, ComptrollerABI.abi, networkConnection.provider);
    _this._auriLens = new Contract(networkAddresses.misc.AURILENS, AuriLensABI.abi, networkConnection.provider);
    return _this;
  }

  var _proto = MoneyMarketRead.prototype;

  _proto.getRewardSpeeds = /*#__PURE__*/function () {
    var _getRewardSpeeds = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
      var speeds;
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this._auriLens.getRewardSpeeds(this._comptroller.address, this.auToken.address);

            case 2:
              speeds = _context.sent;
              return _context.abrupt("return", speeds);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function getRewardSpeeds() {
      return _getRewardSpeeds.apply(this, arguments);
    }

    return getRewardSpeeds;
  }();

  _proto.getTotalTokenBorrowed = /*#__PURE__*/function () {
    var _getTotalTokenBorrowed = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2() {
      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = TokenAmount;
              _context2.t1 = this.underlying;
              _context2.next = 4;
              return this.auToken.totalBorrows();

            case 4:
              _context2.t2 = _context2.sent.toString();
              return _context2.abrupt("return", new _context2.t0(_context2.t1, _context2.t2));

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function getTotalTokenBorrowed() {
      return _getTotalTokenBorrowed.apply(this, arguments);
    }

    return getTotalTokenBorrowed;
  }();

  _proto.getTotalTokenDeposited = /*#__PURE__*/function () {
    var _getTotalTokenDeposited = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3() {
      var _this2 = this;

      var promises, totalBorrow, totalCash;
      return runtime_1.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              promises = [];
              promises.push(this.getTotalTokenBorrowed().then(function (res) {
                totalBorrow = res;
              }));
              promises.push(this.auToken.getCash().then(function (res) {
                totalCash = new TokenAmount(_this2.underlying, res.toString());
              }));
              _context3.next = 5;
              return Promise.all(promises);

            case 5:
              return _context3.abrupt("return", new TokenAmount(this.underlying, BigNumber$1.from(totalCash.rawAmount()).add(totalBorrow.rawAmount()).toString()));

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function getTotalTokenDeposited() {
      return _getTotalTokenDeposited.apply(this, arguments);
    }

    return getTotalTokenDeposited;
  }();

  _proto.getDepositAPY = /*#__PURE__*/function () {
    var _getDepositAPY = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee4() {
      var supplyRatePerTimestamp;
      return runtime_1.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.auToken.supplyRatePerTimestamp();

            case 2:
              supplyRatePerTimestamp = _context4.sent;
              return _context4.abrupt("return", new BigNumber(supplyRatePerTimestamp.toString()).multipliedBy(60 * 60 * 24 * 365).div(decimalFactor(18)));

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function getDepositAPY() {
      return _getDepositAPY.apply(this, arguments);
    }

    return getDepositAPY;
  }();

  _proto.getBorrowAPY = /*#__PURE__*/function () {
    var _getBorrowAPY = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee5() {
      var borrowRatePerTimestamp;
      return runtime_1.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.auToken.borrowRatePerTimestamp();

            case 2:
              borrowRatePerTimestamp = _context5.sent;
              return _context5.abrupt("return", new BigNumber(borrowRatePerTimestamp.toString()).multipliedBy(60 * 60 * 24 * 365).div(decimalFactor(18)));

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function getBorrowAPY() {
      return _getBorrowAPY.apply(this, arguments);
    }

    return getBorrowAPY;
  }();

  _proto.getCollateralRatio = /*#__PURE__*/function () {
    var _getCollateralRatio = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee6() {
      return runtime_1.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", this._comptroller.markets(this.auToken.address).then(function (res) {
                return new BigNumber(res.collateralFactorMantissa.toString()).div(decimalFactor(18));
              }));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function getCollateralRatio() {
      return _getCollateralRatio.apply(this, arguments);
    }

    return getCollateralRatio;
  }();

  _proto.getBorrowPlyAPY = /*#__PURE__*/function () {
    var _getBorrowPlyAPY = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee7() {
      var promises, totalBorrowed, rewardSpeed, plyPrice, underlyingPrice;
      return runtime_1.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              promises = [];
              promises.push(this.getTotalTokenBorrowed().then(function (res) {
                totalBorrowed = res;
              }));
              promises.push(this._comptroller.rewardSpeeds(ComptrollerRewardType.PLY, this.auToken.address, false).then(function (res) {
                rewardSpeed = new TokenAmount(PLYToken, res.toString());
              }));
              promises.push(fetchPrice(networkAddresses.tokens.PLY, this._networkConnection.provider).then(function (res) {
                plyPrice = res;
              }));
              promises.push(fetchPrice(this.underlying.address, this._networkConnection.provider).then(function (res) {
                underlyingPrice = res;
              }));
              _context7.next = 7;
              return Promise.all(promises);

            case 7:
              return _context7.abrupt("return", calcLMRewardApr(plyPrice.multipliedBy(rewardSpeed.formattedAmount()), underlyingPrice.multipliedBy(totalBorrowed.formattedAmount()), ONE_YEAR));

            case 8:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function getBorrowPlyAPY() {
      return _getBorrowPlyAPY.apply(this, arguments);
    }

    return getBorrowPlyAPY;
  }();

  _proto.getDepositPlyAPY = /*#__PURE__*/function () {
    var _getDepositPlyAPY = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee8() {
      var promises, totalDeposited, rewardSpeed, plyPrice, underlyingPrice;
      return runtime_1.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              promises = [];
              promises.push(this.getTotalTokenDeposited().then(function (res) {
                totalDeposited = res;
              }));
              promises.push(this._comptroller.rewardSpeeds(ComptrollerRewardType.PLY, this.auToken.address, true).then(function (res) {
                rewardSpeed = new TokenAmount(PLYToken, res.toString());
              }));
              promises.push(fetchPrice(networkAddresses.tokens.PLY, this._networkConnection.provider).then(function (res) {
                plyPrice = res;
              }));
              promises.push(fetchPrice(this.underlying.address, this._networkConnection.provider).then(function (res) {
                underlyingPrice = res;
              }));
              _context8.next = 7;
              return Promise.all(promises);

            case 7:
              return _context8.abrupt("return", calcLMRewardApr(plyPrice.multipliedBy(rewardSpeed.formattedAmount()), underlyingPrice.multipliedBy(totalDeposited.formattedAmount()), ONE_YEAR));

            case 8:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function getDepositPlyAPY() {
      return _getDepositPlyAPY.apply(this, arguments);
    }

    return getDepositPlyAPY;
  }();

  _proto.getDetails = /*#__PURE__*/function () {
    var _getDetails = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee9() {
      var promises, totalDeposited, totalBorrowed, depositAPY, borrowAPY, collateralRatio, plyPrice, underlyingPrice, rewardSpeeds, borrowPlyApy, depositPlyApy;
      return runtime_1.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              promises = [];
              promises.push(this.getTotalTokenDeposited().then(function (res) {
                totalDeposited = res;
              }));
              promises.push(this.getTotalTokenBorrowed().then(function (res) {
                totalBorrowed = res;
              }));
              promises.push(this.getDepositAPY().then(function (res) {
                depositAPY = res.toNumber();
              }));
              promises.push(this.getBorrowAPY().then(function (res) {
                borrowAPY = res.toNumber();
              }));
              promises.push(this.getCollateralRatio().then(function (res) {
                collateralRatio = res.toNumber();
              }));
              promises.push(this.getRewardSpeeds().then(function (res) {
                rewardSpeeds = res;
              }));
              promises.push(fetchPrice(networkAddresses.tokens.PLY, this._networkConnection.provider).then(function (res) {
                plyPrice = res;
              }));
              promises.push(fetchPrice(this.underlying.address, this._networkConnection.provider).then(function (res) {
                underlyingPrice = res;
              }));
              _context9.next = 11;
              return Promise.all(promises);

            case 11:
              borrowPlyApy = calcLMRewardApr(calcValuation(new TokenAmount(PLYToken, rewardSpeeds.plyRewardBorrowSpeed.toString()), plyPrice), underlyingPrice.multipliedBy(totalBorrowed.formattedAmount()), ONE_YEAR);
              depositPlyApy = calcLMRewardApr(calcValuation(new TokenAmount(PLYToken, rewardSpeeds.plyRewardSupplySpeed.toString()), plyPrice), underlyingPrice.multipliedBy(totalDeposited.formattedAmount()), ONE_YEAR);
              return _context9.abrupt("return", {
                auTokenAddress: this.auToken.address,
                totalTokenDeposited: totalDeposited,
                totalTokenBorrowed: totalBorrowed,
                depositApy: depositAPY,
                depositPlyApy: depositPlyApy.toNumber(),
                borrowApy: borrowAPY,
                borrowPlyApy: borrowPlyApy.toNumber(),
                collateralRatio: collateralRatio
              });

            case 14:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function getDetails() {
      return _getDetails.apply(this, arguments);
    }

    return getDetails;
  }();

  _proto.getUserBorrowBalance = /*#__PURE__*/function () {
    var _getUserBorrowBalance = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee10(userAddress) {
      var totalBorrow;
      return runtime_1.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.auToken.callStatic.borrowBalanceCurrent(userAddress);

            case 2:
              totalBorrow = _context10.sent;
              return _context10.abrupt("return", new TokenAmount(this.underlying, totalBorrow.toString()));

            case 4:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    function getUserBorrowBalance(_x) {
      return _getUserBorrowBalance.apply(this, arguments);
    }

    return getUserBorrowBalance;
  }();

  _proto.getUserDepositBalance = /*#__PURE__*/function () {
    var _getUserDepositBalance = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee11(userAddress) {
      var totalDeposit;
      return runtime_1.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.auToken.callStatic.balanceOfUnderlying(userAddress);

            case 2:
              totalDeposit = _context11.sent;
              return _context11.abrupt("return", new TokenAmount(this.underlying, totalDeposit.toString()));

            case 4:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));

    function getUserDepositBalance(_x2) {
      return _getUserDepositBalance.apply(this, arguments);
    }

    return getUserDepositBalance;
  }();

  return MoneyMarketRead;
}(BlockchainEntityRead);
var MoneyMarketReadWrite = /*#__PURE__*/function (_MoneyMarketRead) {
  _inheritsLoose(MoneyMarketReadWrite, _MoneyMarketRead);

  function MoneyMarketReadWrite(networkConnection, auToken, underlyingAsset) {
    var _this3;

    _this3 = _MoneyMarketRead.call(this, networkConnection, auToken, underlyingAsset) || this;
    _this3._EthRepayHelper = new Contract(networkAddresses.misc.ETHREPAYHELPER, EthRepayHelperABI.abi, networkConnection.provider);
    return _this3;
  }

  var _proto2 = MoneyMarketReadWrite.prototype;

  _proto2.deposit = /*#__PURE__*/function () {
    var _deposit = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee12(amount) {
      return runtime_1.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              if (!isSameAddress(amount.token.address, ETHAddress)) {
                _context12.next = 4;
                break;
              }

              return _context12.abrupt("return", this.auToken.connect(this._networkConnection.signer).mint({
                value: amount.rawAmount()
              }));

            case 4:
              return _context12.abrupt("return", this.auToken.connect(this._networkConnection.signer).mint(amount.rawAmount()));

            case 5:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));

    function deposit(_x3) {
      return _deposit.apply(this, arguments);
    }

    return deposit;
  }();

  _proto2.borrow = /*#__PURE__*/function () {
    var _borrow = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee13(amount) {
      return runtime_1.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", this.auToken.connect(this._networkConnection.signer).borrow(amount.rawAmount()));

            case 1:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this);
    }));

    function borrow(_x4) {
      return _borrow.apply(this, arguments);
    }

    return borrow;
  }();

  _proto2.withdraw = /*#__PURE__*/function () {
    var _withdraw = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee14(amount) {
      return runtime_1.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              if (!new BigNumber(amount.rawAmount()).lt(0)) {
                _context14.next = 2;
                break;
              }

              return _context14.abrupt("return", this.auToken.connect(this._networkConnection.signer).redeemUnderlying(INF));

            case 2:
              return _context14.abrupt("return", this.auToken.connect(this._networkConnection.signer).redeemUnderlying(amount.rawAmount()));

            case 3:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this);
    }));

    function withdraw(_x5) {
      return _withdraw.apply(this, arguments);
    }

    return withdraw;
  }();

  _proto2.repay = /*#__PURE__*/function () {
    var _repay = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee15(amount) {
      return runtime_1.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              if (!isSameAddress(amount.token.address, ETHAddress)) {
                _context15.next = 4;
                break;
              }

              return _context15.abrupt("return", this._EthRepayHelper.connect(this._networkConnection.signer).repayBorrow({
                value: amount.rawAmount()
              }));

            case 4:
              if (!new BigNumber(amount.rawAmount()).lt(0)) {
                _context15.next = 8;
                break;
              }

              return _context15.abrupt("return", this.auToken.connect(this._networkConnection.signer).repayBorrow(INF));

            case 8:
              return _context15.abrupt("return", this.auToken.connect(this._networkConnection.signer).repayBorrow(amount.rawAmount()));

            case 9:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, this);
    }));

    function repay(_x6) {
      return _repay.apply(this, arguments);
    }

    return repay;
  }();

  _proto2.enableCollateral = /*#__PURE__*/function () {
    var _enableCollateral = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee16() {
      return runtime_1.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt("return", this._comptroller.connect(this._networkConnection.signer).enterMarkets([this.auToken.address]));

            case 1:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, this);
    }));

    function enableCollateral() {
      return _enableCollateral.apply(this, arguments);
    }

    return enableCollateral;
  }();

  _proto2.disableCollateral = /*#__PURE__*/function () {
    var _disableCollateral = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee17() {
      return runtime_1.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              return _context17.abrupt("return", this._comptroller.connect(this._networkConnection.signer).exitMarket(this.auToken.address));

            case 1:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, this);
    }));

    function disableCollateral() {
      return _disableCollateral.apply(this, arguments);
    }

    return disableCollateral;
  }();

  return MoneyMarketReadWrite;
}(MoneyMarketRead);
var MoneyMarket = /*#__PURE__*/function (_BlockchainEntity) {
  _inheritsLoose(MoneyMarket, _BlockchainEntity);

  function MoneyMarket(address, underlying) {
    var _this4;

    _this4 = _BlockchainEntity.call(this) || this;
    _this4.address = validateAndParseAddress(address);
    _this4.underlying = validateAndParseAddress(underlying);
    return _this4;
  }

  var _proto3 = MoneyMarket.prototype;

  _proto3.read = function read(networkConnection) {
    return new MoneyMarketRead(networkConnection, this.address, this.underlying);
  };

  _proto3.readWrite = function readWrite(networkConnection) {
    return new MoneyMarketReadWrite(networkConnection, this.address, this.underlying);
  };

  return MoneyMarket;
}(BlockchainEntity);

var SdkRead = /*#__PURE__*/function (_BlockchainEntityRead) {
  _inheritsLoose(SdkRead, _BlockchainEntityRead);

  function SdkRead(networkConnection) {
    var _this;

    _this = _BlockchainEntityRead.call(this, networkConnection) || this;
    _this._comptroller = new Contract(networkAddresses.misc.COMPTROLLER, ComptrollerABI.abi, networkConnection.provider);
    _this._tokenLock = new Contract(networkAddresses.misc.TOKENLOCK, TokenLockABI.abi, networkConnection.provider);
    _this._auriFairLaunch = new Contract(networkAddresses.misc.AURIFAIRLAUNCH, AuriFairLaunchABI.abi, networkConnection.provider);
    _this._auriLens = new Contract(networkAddresses.misc.AURILENS, AuriLensABI.abi, networkConnection.provider);
    return _this;
  }

  var _proto = SdkRead.prototype;

  _proto.getLockingDetails = /*#__PURE__*/function () {
    var _getLockingDetails = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
      var currentTime, currentWeek, denominator, promises, values;
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getCurrentTimestamp(this._networkConnection.provider);

            case 2:
              currentTime = _context.sent;
              currentWeek = BigNumber$1.from(currentTime - REWARDCLAIMSTART).div(7 * ONE_DAY).toNumber();
              denominator = 10000;
              promises = [];
              promises.push(this._tokenLock.percentageLock(currentWeek));
              promises.push(this._tokenLock.percentageLock(currentWeek + 1)["catch"](function (err) {
                return denominator;
              }));
              _context.next = 10;
              return Promise.all(promises).then(function (res) {
                return res.map(function (v) {
                  return v.toString();
                });
              });

            case 10:
              values = _context.sent;
              return _context.abrupt("return", {
                vestingStart: REWARDCLAIMSTART,
                currentUnlockPortion: new BigNumber(denominator).minus(values[0]).div(denominator).toNumber(),
                nextUnlockPortion: new BigNumber(denominator).minus(values[1]).div(denominator).toNumber()
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function getLockingDetails() {
      return _getLockingDetails.apply(this, arguments);
    }

    return getLockingDetails;
  }();

  _proto.getUserDetails = /*#__PURE__*/function () {
    var _getUserDetails = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(userAddress) {
      var _this2 = this;

      var marketCount, userMarketDetails, assetsIn, promises, totalBorrowLimit, pricePromises, _loop2, _iterator, _step, underlyingPrices, depositValues, _loop, i, accountLiquidity, rewardBalancesMetadata, lockedAmount, values, borrowedvaluation, bufferedBorrowLimit, minimumBorrowLimitAllowed, borrowableAmount, auToken, moneyMarket, borrowLimitMargin, maxWithdrawCap;

      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              marketCount = networkAddresses.auTokens.length;
              userMarketDetails = [];
              promises = [];
              totalBorrowLimit = new BigNumber(0);
              pricePromises = [];

              _loop2 = function _loop2() {
                var auToken = _step.value;
                var userMarketDetail = {};
                userMarketDetails.push(userMarketDetail);
                userMarketDetail.market = auToken.underlying;
                var moneyMarket = new MoneyMarketRead(_this2._networkConnection, auToken.address, auToken.underlying);
                promises.push(moneyMarket.getUserDepositBalance(userAddress).then(function (res) {
                  userMarketDetail.depositBalance = res;
                }));
                promises.push(moneyMarket.getUserBorrowBalance(userAddress).then(function (res) {
                  userMarketDetail.borrowBalance = res;
                }));
                promises.push(moneyMarket.getCollateralRatio().then(function (res) {
                  userMarketDetail.collateralRatio = res.toNumber();
                }));
                pricePromises.push(fetchPrice(moneyMarket.underlying.address, _this2._networkConnection.provider).then(function (res) {
                  userMarketDetail.underlyingPrice = res.toString();
                  return res;
                }));
              };

              for (_iterator = _createForOfIteratorHelperLoose(networkAddresses.auTokens); !(_step = _iterator()).done;) {
                _loop2();
              }

              promises.push(this._comptroller.getAssetsIn(userAddress).then(function (res) {
                assetsIn = res;
              }));
              _context2.next = 10;
              return Promise.all(promises);

            case 10:
              _context2.next = 12;
              return Promise.all(pricePromises);

            case 12:
              underlyingPrices = _context2.sent;
              depositValues = [];

              _loop = function _loop() {
                var auToken = networkAddresses.auTokens[i];

                if (assetsIn.find(function (auAddress) {
                  return isSameAddress(auToken.address, auAddress);
                }) !== undefined) {
                  userMarketDetails[i].isCollateral = true;
                } else {
                  userMarketDetails[i].isCollateral = false;
                }

                depositValues.push(calcValuation(userMarketDetails[i].depositBalance, underlyingPrices[i]));
              };

              for (i = 0; i < marketCount; i++) {
                _loop();
              }

              totalBorrowLimit = depositValues.reduce(function (p, v, index) {
                if (userMarketDetails[index].isCollateral) return p.plus(v.multipliedBy(userMarketDetails[index].collateralRatio));
                return p;
              }, new BigNumber(0));
              promises = new Array(3);
              promises[0] = this._comptroller.getAccountLiquidity(userAddress);
              promises[1] = this._auriLens.callStatic.claimAndGetRewardBalancesMetadata(this._comptroller.address, this._auriFairLaunch.address, [AurPlyPid], {
                from: userAddress
              })["catch"](function (err) {
                return {
                  plyAccrued: BigNumber$1.from(0)
                };
              });
              promises[2] = this._tokenLock.lockedAmounts(userAddress);
              _context2.next = 23;
              return Promise.all(promises);

            case 23:
              values = _context2.sent;
              accountLiquidity = values[0];
              rewardBalancesMetadata = values[1];
              lockedAmount = values[2];
              borrowedvaluation = totalBorrowLimit.minus(new BigNumber(accountLiquidity[0].toString()).div(decimalFactor(18)));

              if (borrowedvaluation.lt("0.00001")) {
                borrowedvaluation = new BigNumber(0);
              }

              bufferedBorrowLimit = totalBorrowLimit.multipliedBy(BORROW_LIMIT_BUFFER);
              minimumBorrowLimitAllowed = borrowedvaluation.div(BORROW_LIMIT_BUFFER);

              if (bufferedBorrowLimit.lte(borrowedvaluation)) {
                borrowableAmount = new BigNumber(0);
              } else {
                borrowableAmount = bufferedBorrowLimit.minus(borrowedvaluation);
              }

              for (i = 0; i < marketCount; i++) {
                auToken = networkAddresses.auTokens[i];
                moneyMarket = new MoneyMarketRead(this._networkConnection, auToken.address, auToken.underlying);
                borrowLimitMargin = totalBorrowLimit.minus(minimumBorrowLimitAllowed).gt(0) ? totalBorrowLimit.minus(minimumBorrowLimitAllowed) : new BigNumber(0);
                maxWithdrawCap = borrowLimitMargin.div(userMarketDetails[i].collateralRatio).div(underlyingPrices[i]);
                userMarketDetails[i].maxWithdrawableAmount = userMarketDetails[i].isCollateral && maxWithdrawCap.lt(userMarketDetails[i].depositBalance.formattedAmount()) ? new TokenAmount(moneyMarket.underlying, maxWithdrawCap.toFixed(24), false) : new TokenAmount(moneyMarket.underlying, userMarketDetails[i].depositBalance.rawAmount());
              }

              return _context2.abrupt("return", {
                markets: userMarketDetails,
                borrowLimit: {
                  currency: "USD",
                  amount: bufferedBorrowLimit.toFixed(DECIMAL_PRECISION)
                },
                accruedPly: new TokenAmount(PLYToken, rewardBalancesMetadata.plyAccrued.toString()),
                lockedPly: new TokenAmount(PLYToken, lockedAmount.toString()),
                borrowableAmount: {
                  currency: "USD",
                  amount: borrowableAmount.toFixed(DECIMAL_PRECISION)
                }
              });

            case 34:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function getUserDetails(_x) {
      return _getUserDetails.apply(this, arguments);
    }

    return getUserDetails;
  }();

  _proto.getPlyAuroraPoolDetails = /*#__PURE__*/function () {
    var _getPlyAuroraPoolDetails = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3() {
      var stakedLiquidity, rewardPerSecond, promises, rewardPerSecondValuation, totalStakeValuation;
      return runtime_1.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              promises = [];
              promises.push(this._auriFairLaunch.getPoolInfo(AurPlyPid).then(function (res) {
                stakedLiquidity = res.totalStake;
                rewardPerSecond = res.rewardPerSecond;
              }));
              _context3.next = 4;
              return Promise.all(promises);

            case 4:
              promises = [];
              promises.push(fetchValuation(new TokenAmount(PLYToken, rewardPerSecond.toString()), this._networkConnection.provider).then(function (res) {
                return rewardPerSecondValuation = res;
              }));
              promises.push(fetchValuation(new TokenAmount(AURPLYToken, stakedLiquidity.toString()), this._networkConnection.provider).then(function (res) {
                return totalStakeValuation = res;
              }));
              _context3.next = 9;
              return Promise.all(promises);

            case 9:
              return _context3.abrupt("return", {
                totalStakedLiquidity: new TokenAmount(AURPLYToken, stakedLiquidity.toString()),
                apy: calcLMRewardApr(rewardPerSecondValuation, totalStakeValuation, ONE_DAY * 365).toFixed(DECIMAL_PRECISION)
              });

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function getPlyAuroraPoolDetails() {
      return _getPlyAuroraPoolDetails.apply(this, arguments);
    }

    return getPlyAuroraPoolDetails;
  }();

  _proto.getTokenPrice = /*#__PURE__*/function () {
    var _getTokenPrice = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee4(token) {
      var price;
      return runtime_1.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return fetchPrice(token.address, this._networkConnection.provider);

            case 2:
              price = _context4.sent;
              return _context4.abrupt("return", {
                currency: "USD",
                amount: price.toFixed(DECIMAL_PRECISION)
              });

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function getTokenPrice(_x2) {
      return _getTokenPrice.apply(this, arguments);
    }

    return getTokenPrice;
  }();

  _proto.stakeBalanceOf = /*#__PURE__*/function () {
    var _stakeBalanceOf = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee5(user) {
      var userInfo;
      return runtime_1.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this._auriFairLaunch.getUserInfo(AurPlyPid, user);

            case 2:
              userInfo = _context5.sent;
              return _context5.abrupt("return", new TokenAmount(AURPLYToken, userInfo.amount.toString()));

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function stakeBalanceOf(_x3) {
      return _stakeBalanceOf.apply(this, arguments);
    }

    return stakeBalanceOf;
  }();

  _proto.calcHypotheticalStats = function calcHypotheticalStats(_ref) {
    var userMarketDetail = _ref.userMarketDetail,
        currentBorrowLimit = _ref.currentBorrowLimit,
        currentBorrowValuation = _ref.currentBorrowValuation,
        action = _ref.action,
        tokenAmount = _ref.tokenAmount;
    var newBorrowLimit = new BigNumber(currentBorrowLimit.amount),
        newBorrowValuation = new BigNumber(currentBorrowValuation.amount);

    switch (action) {
      case MarketAction.EnableCollateral:
      case MarketAction.DisableCollateral:
        var deltaBorrowLimit = calcValuation(userMarketDetail.depositBalance, new BigNumber(userMarketDetail.underlyingPrice)).multipliedBy(userMarketDetail.collateralRatio).multipliedBy(BORROW_LIMIT_BUFFER);
        newBorrowLimit = action == MarketAction.EnableCollateral ? newBorrowLimit.plus(deltaBorrowLimit) : newBorrowLimit.minus(deltaBorrowLimit);
        break;

      case MarketAction.Deposit:
      case MarketAction.Withdraw:
        deltaBorrowLimit = calcValuation(tokenAmount, new BigNumber(userMarketDetail.underlyingPrice)).multipliedBy(userMarketDetail.collateralRatio).multipliedBy(BORROW_LIMIT_BUFFER);
        newBorrowLimit = action == MarketAction.Deposit ? newBorrowLimit.plus(deltaBorrowLimit) : newBorrowLimit.minus(deltaBorrowLimit);
        break;

      case MarketAction.Borrow:
      case MarketAction.Repay:
        var deltaBorrowValuation = calcValuation(tokenAmount, new BigNumber(userMarketDetail.underlyingPrice));
        newBorrowValuation = action == MarketAction.Borrow ? newBorrowValuation.plus(deltaBorrowValuation) : newBorrowValuation.minus(deltaBorrowValuation);
        break;
    }

    return {
      newBorrowLimit: {
        amount: newBorrowLimit.toFixed(DECIMAL_PRECISION),
        currency: "USD"
      },
      newBorrowUtilization: newBorrowLimit.eq(0) ? newBorrowValuation.eq(0) ? 0 : 9999.99 : newBorrowValuation.div(newBorrowLimit).toNumber()
    };
  };

  return SdkRead;
}(BlockchainEntityRead);
var SdkReadWrite = /*#__PURE__*/function (_SdkRead) {
  _inheritsLoose(SdkReadWrite, _SdkRead);

  function SdkReadWrite() {
    return _SdkRead.apply(this, arguments) || this;
  }

  var _proto2 = SdkReadWrite.prototype;

  _proto2.claim = /*#__PURE__*/function () {
    var _claim = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee6() {
      return runtime_1.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", this._auriLens.connect(this._networkConnection.signer).claimRewards(this._comptroller.address, this._auriFairLaunch.address, [AurPlyPid]));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function claim() {
      return _claim.apply(this, arguments);
    }

    return claim;
  }();

  _proto2.stake = /*#__PURE__*/function () {
    var _stake = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee7(amount) {
      return runtime_1.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", this._auriFairLaunch.connect(this._networkConnection.signer).deposit(AurPlyPid, amount.rawAmount()));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function stake(_x4) {
      return _stake.apply(this, arguments);
    }

    return stake;
  }();

  _proto2.unstake = /*#__PURE__*/function () {
    var _unstake = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee8(amount) {
      return runtime_1.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", this._auriFairLaunch.connect(this._networkConnection.signer).withdraw(AurPlyPid, amount.rawAmount()));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function unstake(_x5) {
      return _unstake.apply(this, arguments);
    }

    return unstake;
  }();

  _proto2.faucetDrip = /*#__PURE__*/function () {
    var _faucetDrip = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee9() {
      var faucet;
      return runtime_1.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              faucet = new Contract(networkAddresses.misc.FAUCET, FaucetABI.abi, this._networkConnection.provider);
              return _context9.abrupt("return", faucet.connect(this._networkConnection.signer).drip());

            case 2:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function faucetDrip() {
      return _faucetDrip.apply(this, arguments);
    }

    return faucetDrip;
  }();

  return SdkReadWrite;
}(SdkRead);
var SDK = /*#__PURE__*/function (_BlockchainEntity) {
  _inheritsLoose(SDK, _BlockchainEntity);

  function SDK() {
    return _BlockchainEntity.call(this) || this;
  }

  var _proto3 = SDK.prototype;

  _proto3.read = function read(networkConnection) {
    return new SdkRead(networkConnection);
  };

  _proto3.readWrite = function readWrite(networkConnection) {
    return new SdkReadWrite(networkConnection);
  };

  return SDK;
}(BlockchainEntity);

var dummyToken = /*#__PURE__*/new Token('0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e', 6);
var dummyPly = /*#__PURE__*/new Token('0x8729438eb15e2c8b576fcc6aecda6a148776c0f5', 18);
var dummyPlyAurora = /*#__PURE__*/new Token('0xE530dC2095Ef5653205CF5ea79F8979a7028065c', 18);
var dummyTokenAmount = /*#__PURE__*/new TokenAmount(dummyToken, '123.456', false);
var dummyZeroTokenAmount = /*#__PURE__*/new TokenAmount(dummyToken, '0');
var dummyTokenAmount2 = /*#__PURE__*/new TokenAmount(dummyToken, '456.123', false);
var dummyTokenAmount3 = /*#__PURE__*/new TokenAmount(dummyToken, '1000.123', false);
var dummyMarketAddress = '0xbeb5d47a3f720ec0a390d04b4d41ed7d9688bc7f';
var dummyUserMarketDetails = {
  market: dummyMarketAddress,
  depositBalance: dummyTokenAmount2,
  borrowBalance: dummyZeroTokenAmount,
  isCollateral: true,
  maxWithdrawableAmount: dummyTokenAmount,
  collateralRatio: 0.5,
  underlyingPrice: "1"
};

ethers.utils.Logger.setLogLevel(Logger.levels.ERROR);

export { AURORA_CHAINID, AURPLYToken, AurPlyPid, BORROW_LIMIT_BUFFER, BlockchainEntity, BlockchainEntityRead, BlockchainEntityReadWrite, ComptrollerRewardType, DECIMAL_PRECISION, ETHAddress, INF, MarketAction, MoneyMarket, MoneyMarketRead, MoneyMarketReadWrite, ONE_DAY, ONE_YEAR, PLYToken, REWARDCLAIMSTART, SDK, SdkRead, SdkReadWrite, Token, TokenAmount, calcLMRewardApr, calcValuation, decimalFactor, dummyAddress, dummyMarketAddress, dummyPly, dummyPlyAurora, dummyToken, dummyTokenAmount, dummyTokenAmount2, dummyTokenAmount3, dummyUserMarketDetails, dummyZeroTokenAmount, fetchLPPositions, fetchLPPrice, fetchPrice, fetchPriceFromCoingecko, fetchPriceFromCoingeckoAPI, fetchPriceFromOracle, fetchUnderlyingTokensPrices, fetchValuation, formatObject, getCurrentTimestamp, getDecimal, isSameAddress, networkAddresses, validateAndParseAddress };
//# sourceMappingURL=sdk.esm.js.map
